import styled from "styled-components";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import {
  Button as DSButton,
  colors,
  TextLink,
  textLinkTypography,
  typography
} from "design-system";

import { postSubmitImage } from "src/features/contact-boxes/components/ExpertsHDPContactBox/assets";
import { smallScreen } from "src/shared/constants/screenSizes";

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 670px;
  position: relative;

  @media screen and (min-width: ${smallScreen}px) {
    min-height: 800px;
  }
`;

export const DrawerCloseButton = styled(XButton)`
  display: none;

  @media screen and (min-width: ${smallScreen}px) {
    display: block;
    position: absolute;
    right: -16px;
    top: -16px;
  }
`;

export const BackgroundImage = styled.img.attrs({
  src: postSubmitImage
})`
  bottom: -99px;
  left: -24px;
  position: absolute;
  width: calc(100% + 48px);
  height: auto;

  @media screen and (min-width: ${smallScreen}px) {
    bottom: -80px;
    left: -60px;
    width: calc(100% + 120px);
  }
`;

export const Separator = styled.div`
  background-color: ${colors.GRAY_LIGHT};
  height: 1px;
  margin: 24px 0;
  width: 100%;
`;

export const Text = styled(typography.Body)`
  margin-bottom: 24px;
`;

export const CaptionText = styled(typography.Caption)`
  color: ${colors.TEXT_SECONDARY};
  margin: 24px 0 16px;
  text-align: center;

  @media screen and (min-width: ${smallScreen}px) {
    margin: 24px 0;
  }
`;

export const ButtonContainer = styled.div`
  @media screen and (max-width: ${smallScreen - 1}px) {
    background: ${colors.WHITE};
    border-top: 1px solid ${colors.GRAY_LIGHT};
    bottom: 0;
    left: 0;
    padding: 16px 24px;
    position: fixed;
    width: 100%;
  }
`;

export const PrimaryButton = styled(DSButton).attrs({ type: "button" })`
  width: 100%;

  @media screen and (min-width: ${smallScreen}px) {
    margin-bottom: 24px;
    width: 280px;
  }
`;

export const SecondaryButton = styled(TextLink).attrs({
  href: "#",
  typography: textLinkTypography.CAPS,
  underlined: false
})`
  &:hover,
  &:active {
    background-color: transparent;
  }
`;
